import { useEffect, useState } from "react";
import { Download, Share, X } from "lucide-react";

let deferred = null;
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferred = e;
    window.dispatchEvent(new Event("gogoats-installable"));
  });
}

const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);

export const InstallPrompt = ({ force = false }) => {
  const [can, setCan] = useState(!!deferred);
  const [hidden, setHidden] = useState(!force && localStorage.getItem("gogoats_install_dismissed") === "1");

  useEffect(() => {
    const on = () => setCan(true);
    window.addEventListener("gogoats-installable", on);
    return () => window.removeEventListener("gogoats-installable", on);
  }, []);

  if (isStandalone() || hidden) return null;
  const ios = isIOS();

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    deferred = null;
    setCan(false);
  };

  return (
    <div data-testid="install-prompt" className="relative overflow-hidden rounded-3xl border border-cyan-200 bg-gradient-to-br from-cyan-100 via-sky-50 to-white p-4 flex gap-3 items-center">
      <img src="/icon-192.png" alt="Gogoats" className="w-14 h-14 rounded-2xl object-cover" />
      <div className="flex-1 min-w-0">
        <p className="font-display font-bold text-sm">INSTALLER GOGOATS</p>
        <p className="text-xs text-slate-600 leading-snug mt-0.5">Ajoutez Gogoats à votre écran d'accueil pour accéder rapidement au match chaque semaine.</p>
        {ios ? (
          <p className="text-xs text-cyan-700 mt-2 flex items-center gap-1" data-testid="install-ios-hint">
            <Share className="w-3.5 h-3.5" /> Partager → Sur l'écran d'accueil
          </p>
        ) : can ? (
          <button data-testid="install-button" onClick={install} className="mt-2 inline-flex items-center gap-1.5 rounded-full bg-cyan-400 text-zinc-950 text-xs font-bold px-3 py-1.5 active:scale-95 transition-transform">
            <Download className="w-3.5 h-3.5" /> Installer
          </button>
        ) : (
          <p className="text-xs text-slate-500 mt-2" data-testid="install-menu-hint">Menu ⋮ du navigateur → « Ajouter à l'écran d'accueil »</p>
        )}
      </div>
      {!force && (
        <button data-testid="install-dismiss" onClick={() => { localStorage.setItem("gogoats_install_dismissed", "1"); setHidden(true); }} className="absolute top-2 right-2 p-1 text-slate-400">
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
};
